(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // 监听购物车数量变化并同步
  function syncCartCounts() {
    const mainCartBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    const targetCartIcon = document.querySelector('#cart-icon-bubble1');
    if (!targetCartIcon) return;

    let targetCartBubble = targetCartIcon.querySelector('.cart-count-bubble');

    // 购物车为空时，移除右上角数字气泡
    if (!mainCartBubble) {
      if (targetCartBubble) targetCartBubble.remove();
      return;
    }

    const countSpan = mainCartBubble.querySelector('span[aria-hidden="true"]');
    const visibleSpan = mainCartBubble.querySelector('.visually-hidden');
    const countText = countSpan ? countSpan.textContent.trim() : '';
    const countValue = Number(countText || 0);

    if (!Number.isFinite(countValue) || countValue <= 0) {
      if (targetCartBubble) targetCartBubble.remove();
      return;
    }

    if (!targetCartBubble) {
      targetCartBubble = document.createElement('div');
      targetCartBubble.className = 'cart-count-bubble';

      const newCountSpan = document.createElement('span');
      newCountSpan.setAttribute('aria-hidden', 'true');
      targetCartBubble.appendChild(newCountSpan);

      const newVisibleSpan = document.createElement('span');
      newVisibleSpan.className = 'visually-hidden';
      targetCartBubble.appendChild(newVisibleSpan);

      targetCartIcon.appendChild(targetCartBubble);
    }

    const targetCountSpan = targetCartBubble.querySelector('span[aria-hidden="true"]');
    if (targetCountSpan) targetCountSpan.textContent = countText;

    const targetVisibleSpan = targetCartBubble.querySelector('.visually-hidden');
    if (targetVisibleSpan && visibleSpan) {
      targetVisibleSpan.textContent = visibleSpan.textContent;
    }
  }
  
  // 设置一个变化观察器
  const mainCart = document.querySelector('#cart-icon-bubble');
  if (mainCart) {
    const observer = new MutationObserver(syncCartCounts);
    observer.observe(mainCart, { 
      childList: true, 
      subtree: true,
      characterData: true 
    });
  }
  
  // 页面加载时同步一次
  syncCartCounts();
  
  // 在购物车更新时同步
  document.addEventListener('cart:updated', syncCartCounts);

  const desktopInlineSearch = document.querySelector('[data-vision-inline-search]');
  if (desktopInlineSearch) {
    const searchInput = desktopInlineSearch.querySelector('input[type="search"]');
    const clickCapture = desktopInlineSearch.querySelector('.searchform--click-capture');

    const openInlineSearch = () => {
      desktopInlineSearch.classList.add('is-active');
      document.body.classList.add('open-search');
    };

    const closeInlineSearch = () => {
      desktopInlineSearch.classList.remove('is-active');
      document.body.classList.remove('open-search');
    };

    searchInput?.addEventListener('focus', openInlineSearch);
    searchInput?.addEventListener('click', openInlineSearch);

    desktopInlineSearch.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!desktopInlineSearch.contains(document.activeElement)) {
          closeInlineSearch();
        }
      }, 0);
    });

    clickCapture?.addEventListener('click', () => {
      closeInlineSearch();
      searchInput?.blur();
    });

    document.addEventListener('keyup', (event) => {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') {
        closeInlineSearch();
        searchInput?.blur();
      }
    });
  }
});
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 749px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.setHeaderHeight();
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.setHeaderHeight();
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.setHeaderHeight();
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
